<template>
  <div class="page" v-loading="loading">
    <div class="top">
      <div class="left">
        <div class="detail_show">
          <swiper
            v-if="carouselImages.length > 0"
            class="main-swiper"
            :modules="modules"
            :slides-per-view="1"
            :space-between="0"
            :navigation="mainNavigation"
            :pagination="{ clickable: true }"
            :autoplay="mainAutoplay"
            @swiper="onMainSwiper"
            @slide-change="onMainSlideChange"
            @mouseenter="pauseMainAutoplay"
            @mouseleave="resumeMainAutoplay"
          >
            <swiper-slide v-for="(url, index) in carouselImages" :key="index">
              <img class="chooseImg" :src="url" alt="商品主图" />
            </swiper-slide>
          </swiper>
          <img
            v-if="carouselImages.length > 1"
            src="@/assets/images/arrowleft.png"
            class="main-swiper-prev img-btn main-arr main-arr-left"
            alt=""
          />
          <img
            v-if="carouselImages.length > 1"
            src="@/assets/images/arrowright.png"
            class="main-swiper-next img-btn main-arr main-arr-right"
            alt=""
          />
          <div v-else-if="carouselImages.length === 0" class="no-image">
            暂无图片
          </div>
        </div>

        <div class="swiper_content" v-if="carouselImages.length > 0">
          <div class="swiper-box">
            <swiper
              :modules="modules"
              :slides-per-view="4"
              :space-between="0"
              :navigation="thumbNavigation"
            >
              <swiper-slide v-for="(url, index) in carouselImages" :key="index">
                <div class="slider-item" @click="openDetail(index)">
                  <img
                    class="img"
                    :class="{ 'img--active': index === activeImageIndex }"
                    :src="url"
                  />
                </div>
              </swiper-slide>
            </swiper>
            <img
              src="@/assets/images/arrowleft.png"
              class="swiper-button-prev thumb-swiper-prev img-btn arr_left"
              alt=""
            />
            <img
              src="@/assets/images/arrowright.png"
              class="swiper-button-next thumb-swiper-next img-btn arr_right"
              alt=""
            />
          </div>
        </div>
      </div>

      <div class="content_right">
        <div class="content">
          <div class="title">{{ renderData.name }}</div>
          <div class="tag" v-if="renderData.tags && renderData.tags.length > 0">
            <div
              class="item new"
              v-for="item in renderData.tags"
              :key="item.id"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="price_list">
            <div class="left_content">
              <div class="price">
                ￥{{ selectSku.price || renderData.price || "0.00" }}
              </div>
              <div class="tag">限量</div>
              <div class="kucun">库存：{{ selectSku.stock || 0 }}</div>
            </div>
            <div class="right">
              商品类型：{{
                renderData.typeText || (renderData.type === 1 ? "虚拟" : "实物")
              }}
            </div>
          </div>
          <div class="description" v-if="renderData.description">
            <div class="desc_title">商品描述：</div>
            <div class="desc_content">{{ renderData.description }}</div>
          </div>
          <div class="sku">
            <div class="sku_title">产品规格：</div>
            <div class="sku_list">
              <template v-if="renderData.skus && renderData.skus.length > 0">
                <div
                  class="tag_item"
                  :class="{ tag_active: selectSku.id === item.id }"
                  v-for="item in renderData.skus"
                  :key="item.id"
                  @click="handleSelect(item)"
                >
                  {{ item.skuName }}
                </div>
              </template>
              <div v-else class="no-sku">暂无规格</div>
            </div>
          </div>
          <div class="size">
            <div class="size_title">大小：</div>
            <div class="size_list">
              <div class="tag_item tag_active">盲盒随机发不指定</div>
            </div>
          </div>
          <div class="shuliang">
            <div class="shuliang_title">数量：</div>
            <div class="counter">
              <el-input-number
                v-model="count"
                :min="1"
                :max="selectSku.stock || 1"
                size="large"
                :disabled="!selectSku.id || (selectSku.stock || 0) < 1"
              />
            </div>
            <div class="stock-tip" v-if="selectSku.stock !== undefined">
              <span v-if="selectSku.stock <= 0" class="stock-warning">
                库存不足</span
              >
              <span v-else-if="selectSku.stock < 10" class="stock-low">
                仅剩 {{ selectSku.stock }} 件</span
              >
            </div>
          </div>

          <div class="button_list">
            <el-button
              type="warning"
              class="button"
              @click="handleAddCart"
              :disabled="
                !selectSku.id || (selectSku.stock || 0) < 1 || addCartLoading
              "
              :loading="addCartLoading"
            >
              {{ addCartLoading ? "添加中..." : "加入购物车" }}
            </el-button>
            <el-button
              type="danger"
              class="button m-r-28"
              @click="buyNow"
              :disabled="
                !selectSku.id || (selectSku.stock || 0) < 1 || buyNowLoading
              "
              :loading="buyNowLoading"
            >
              {{ buyNowLoading ? "处理中..." : "立即购买" }}
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="author"
      v-if="renderData.artists && renderData.artists.length > 0"
    >
      <div class="author_title">艺术家</div>
      <div
        class="author_content"
        v-for="artist in renderData.artists"
        :key="artist.id"
      >
        <img :src="artist.avatar" alt="" />
        <div class="tips">
          <div class="artist_name">艺术家·{{ artist.name }}</div>
          <div class="artist_desc" v-if="artist.description">
            {{ artist.description }}
          </div>
        </div>
      </div>
    </div>
    <div
      class="detail"
      v-if="detailImages.length > 0 || renderData.detailContent"
    >
      <div class="detail_title">商品详情</div>
      <div class="detail_content">
        <!-- 详情图片 -->
        <div v-if="detailImages.length > 0" class="detail_images">
          <img
            v-for="(img, index) in detailImages"
            :key="index"
            class="detail_img"
            :src="img"
            alt="商品详情"
          />
        </div>
        <!-- 富文本详情 -->
        <div
          v-if="renderData.detailContent"
          class="detail_html"
          v-html="renderData.detailContent"
        ></div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import { ref, onMounted, watch } from "vue";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { useRoute, useRouter } from "vue-router";
import { useToast } from "vue-toast-notification";
import { getToken } from "@/utils/cookie";
// import { useSureOrderStore } from "@/stores/sureOrder";
import "swiper/css/navigation";
import "swiper/css/pagination"; // 导入 Pagination 样式
import "swiper/css";
const router = useRouter();
import { getProductDetail, addCart } from "@/api/shopping";
const $toast = useToast();
// const sureOrderStore = useSureOrderStore();
const mainNavigation = ref({
  nextEl: ".main-swiper-next",
  prevEl: ".main-swiper-prev",
});
const thumbNavigation = ref({
  nextEl: ".thumb-swiper-next",
  prevEl: ".thumb-swiper-prev",
});
const modules = [Navigation, Pagination, Autoplay];
const mainAutoplay = {
  delay: 3000,
  disableOnInteraction: false,
  pauseOnMouseEnter: true,
};
const loading = ref(true);
const carouselImages = ref([]);
const detailImages = ref([]);
const activeImageIndex = ref(0);
const mainSwiperRef = ref(null);

const renderData = ref({
  id: null,
  name: "",
  type: null,
  typeText: "",
  price: "",
  coverImage: "",
  description: "",
  detailContent: "",
  tags: [],
  artists: [],
  skus: [],
});

const route = useRoute();

onMounted(() => {
  const id = route.params.id;
  if (id) {
    fetchData(id);
  } else {
    loading.value = false;
    $toast.error("商品ID不存在", {
      position: "top",
    });
  }
});

watch(
  () => route.params.id,
  (id) => {
    if (id) fetchData(id);
  }
);

const fetchData = (id) => {
  loading.value = true;
  // 商品信息
  getProductDetail({ goodsId: id })
    .then((res) => {
      if (res && res.code === 200 && res.data) {
        // 滚动到顶部
        window.scrollTo(0, 0);

        // 处理商品数据
        const data = res.data;
        renderData.value = {
          id: data.id || null,
          name: data.name || "",
          type: data.type || null,
          typeText: data.typeText || (data.type === 1 ? "虚拟" : "实物"),
          price: data.price || "",
          coverImage: data.coverImage || "",
          description: data.description || "",
          detailContent: data.detailContent || "",
          tags: Array.isArray(data.tags) ? data.tags : [],
          artists: Array.isArray(data.artists) ? data.artists : [],
          skus: Array.isArray(data.skus) ? data.skus : [],
        };

        // 处理轮播图
        if (
          Array.isArray(data.carouselImages) &&
          data.carouselImages.length > 0
        ) {
          carouselImages.value = data.carouselImages;
          activeImageIndex.value = 0;
        } else if (data.coverImage) {
          // 如果没有轮播图，使用封面图
          carouselImages.value = [data.coverImage];
          activeImageIndex.value = 0;
        } else {
          carouselImages.value = [];
          activeImageIndex.value = 0;
        }

        // 处理详情图
        if (Array.isArray(data.detailImages) && data.detailImages.length > 0) {
          detailImages.value = data.detailImages;
        } else {
          detailImages.value = [];
        }

        // 处理SKU列表
        if (renderData.value.skus && renderData.value.skus.length > 0) {
          selectSku.value = {
            ...renderData.value.skus[0],
            stock: renderData.value.skus[0].stock || 0,
          };
        } else {
          // 如果没有SKU列表，使用默认值
          selectSku.value = {
            skuName: "",
            price: renderData.value.price || "",
            id: "",
            stock: 0,
          };
        }
      } else {
        $toast.error(res?.message || "获取商品详情失败", {
          position: "top",
        });
      }
    })
    .catch((error) => {
      console.error("获取商品详情失败:", error);
      $toast.error("获取商品详情失败，请稍后重试", {
        position: "top",
      });
    })
    .finally(() => {
      loading.value = false;
    });
};

const count = ref(1);
const addCartLoading = ref(false);
const buyNowLoading = ref(false);

const onMainSwiper = (swiper) => {
  mainSwiperRef.value = swiper;
};

const onMainSlideChange = (swiper) => {
  activeImageIndex.value = swiper.activeIndex || 0;
};

const pauseMainAutoplay = () => {
  mainSwiperRef.value?.autoplay?.stop();
};

const resumeMainAutoplay = () => {
  mainSwiperRef.value?.autoplay?.start();
};

const openDetail = (index) => {
  activeImageIndex.value = index;
  mainSwiperRef.value?.slideTo(index);
};

const selectSku = ref({
  id: "",
  skuName: "",
  price: "",
  stock: 0,
});

// 监听SKU变化，自动调整数量
watch(
  () => selectSku.value.stock,
  (newStock) => {
    if (newStock !== undefined && count.value > newStock) {
      count.value = Math.max(1, newStock);
      if (newStock === 0) {
        $toast.warning("该规格库存不足，数量已调整为0", {
          position: "top",
        });
      } else {
        $toast.warning(`该规格仅剩 ${newStock} 件，数量已调整`, {
          position: "top",
        });
      }
    }
  }
);

// 监听数量变化，确保不超过库存
watch(
  () => count.value,
  (newCount) => {
    if (
      selectSku.value.stock !== undefined &&
      newCount > selectSku.value.stock
    ) {
      count.value = selectSku.value.stock;
      $toast.warning(`数量不能超过库存（${selectSku.value.stock}件）`, {
        position: "top",
      });
    }
  }
);

const handleSelect = (info) => {
  selectSku.value = info;
  //切换规格时，数量重置为1，但不能超过库存
  count.value = Math.min(1, info.stock || 1);
};

// 检查登录状态
const checkLogin = () => {
  const token = getToken();
  if (!token) {
    $toast.error("请先登录", {
      position: "top",
    });
    router.push("/login");
    return false;
  }
  return true;
};

// 验证购买条件
const validatePurchase = () => {
  // 检查登录状态
  if (!checkLogin()) {
    return false;
  }

  // 检查是否选择了规格
  if (!selectSku.value.id) {
    $toast.error("请先选择商品规格", {
      position: "top",
    });
    return false;
  }

  // 检查库存
  if (!selectSku.value.stock || selectSku.value.stock < 1) {
    $toast.error("该规格库存不足，无法购买", {
      position: "top",
    });
    return false;
  }

  // 检查数量
  if (!count.value || count.value < 1) {
    $toast.error("购买数量至少为1", {
      position: "top",
    });
    return false;
  }

  if (count.value > selectSku.value.stock) {
    $toast.error(`购买数量不能超过库存（${selectSku.value.stock}件）`, {
      position: "top",
    });
    return false;
  }

  return true;
};

const handleAddCart = async () => {
  // 检查登录状态
  if (!checkLogin()) {
    return;
  }

  // 验证购买条件
  if (!validatePurchase()) {
    return;
  }

  // 验证商品ID
  if (!renderData.value.id) {
    $toast.error("商品信息不完整，请刷新页面重试", {
      position: "top",
    });
    return;
  }

  addCartLoading.value = true;
  try {
    const response = await addCart({
      productId: renderData.value.id,
      skuId: selectSku.value.id,
      quantity: count.value,
    });

    if (response && response.code === 200) {
      $toast.success("加入购物车成功", {
        position: "top",
        duration: 2000,
      });
      // 可以在这里触发购物车数量更新事件
      // 或者跳转到购物车页面
      // router.push('/shoppingCar');
    } else {
      $toast.error(response?.message || "加入购物车失败", {
        position: "top",
      });
    }
  } catch (error) {
    console.error("加入购物车失败:", error);
    const errorMsg =
      error?.response?.data?.message ||
      error?.message ||
      "加入购物车失败，请稍后重试";
    $toast.error(errorMsg, {
      position: "top",
    });
  } finally {
    addCartLoading.value = false;
  }
};

const buyNow = async () => {
  // 检查登录状态
  if (!checkLogin()) {
    return;
  }

  // 验证购买条件
  if (!validatePurchase()) {
    return;
  }

  // 验证商品ID
  if (!renderData.value.id) {
    $toast.error("商品信息不完整，请刷新页面重试", {
      position: "top",
    });
    return;
  }

  buyNowLoading.value = true;
  try {
    // 立即购买：不经过购物车，直接带商品+规格+数量跳转订单确认页
    const payload = {
      direct: true,
      items: [
        {
          productId: renderData.value.id,
          skuId: selectSku.value.id || null,
          quantity: count.value,
        },
      ],
    };
    const encodedData = encodeURIComponent(JSON.stringify(payload));
    router.push(`/sureOrder/${encodedData}`);
  } catch (error) {
    console.error("立即购买失败:", error);
    const errorMsg =
      error?.response?.data?.message ||
      error?.message ||
      "立即购买失败，请稍后重试";
    $toast.error(errorMsg, {
      position: "top",
    });
  } finally {
    buyNowLoading.value = false;
  }
};
</script>

<style lang="scss" scoped>
.page {
  position: relative;
  margin: 86px 360px 0 360px;
  background: transparent;
  min-height: calc(100vh - 86px);
  color: var(--ux-text-primary);
  .top {
    display: flex;
    .left {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-left: 22px;
      margin-top: 50px;
      margin-right: 36px;
      .swiper_content {
        display: flex;
        margin-top: 54px;
        .swiper-box {
          width: 480px;
          position: relative;
          margin: auto;

          .img {
            width: 113.61px;
            height: 120px;
            border-radius: 20px;
            opacity: 0.8;
            border: 2px solid transparent;
            transition: all 0.2s ease;

            &:hover {
              cursor: pointer;
              opacity: 1;
            }
          }
          .img--active {
            opacity: 1;
            border-color: var(--ux-accent, #00d4ff);
            box-shadow: 0 0 0 2px rgba(0, 212, 255, 0.2);
          }
          .arr_left {
            left: -30.002px;
          }
          .arr_right {
            right: -30.002px;
          }
        }
      }
      .detail_show {
        position: relative;
        width: 501px;
        .main-swiper {
          width: 501px;
          height: 594px;
          border-radius: 20px;
          overflow: hidden;
        }
        .main-arr {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          z-index: 2;
          cursor: pointer;
          width: 30px;
          height: 30px;
          opacity: 0.9;
        }
        .main-arr-left {
          left: 8px;
        }
        .main-arr-right {
          right: 8px;
        }
        .chooseImg {
          width: 501px;
          height: 594px;
          border-radius: 20px;
          object-fit: cover;
        }
        .no-image {
          width: 501px;
          height: 594px;
          border-radius: 20px;
          background: var(--ux-glass-bg-subtle);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #999;
          font-size: 16px;
        }
      }
    }
    .content_right {
      margin-top: 20px;
      flex: 1;
      .content {
        display: flex;
        flex-direction: column;
        //   margin: 70px 0 0 -294px;
        .title {
          width: 575px;
          height: 100px;
          font-size: 40px;
          font-weight: 900;
          color: var(--ux-text-primary);
          line-height: 100px;
          letter-spacing: 2.002px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
        .tag {
          display: flex;
          .item {
            width: 67px;
            height: 30px;
            line-height: 30px;
            color: #fff;
            font-size: 18px;
            text-align: center;
            font-weight: 500;
            margin-right: 4px;
          }
          .lianming {
            background: linear-gradient(180deg, #00c1f6 0%, #03d197 99%);
          }
          .new {
            background: linear-gradient(180deg, #04be23 0%, #94d90b 99%);
          }
          .hot {
            background: linear-gradient(180deg, #f64600 0%, #f68700 99%);
          }
        }
        .price_list {
          display: flex;
          padding: 20px 0 20px 0;
          justify-content: space-between;
          align-items: center;
          .left_content {
            display: flex;
            align-items: center;
            flex-direction: row;
            .price {
              font-weight: bold;
              font-size: 40px;
              color: red;
              line-height: 46.998px;
              font-style: normal;
              text-transform: none;
              margin-right: 20px;
            }
            .tag {
              font-size: 18px;
              font-weight: 500;
              color: #f64800;
              margin-right: 5px;
            }
            .kucun {
              font-size: 15px;
              color: var(--ux-text-secondary);
            }
          }
          .right {
            font-size: 18px;
            line-height: 18px;
            margin-right: 28px;
            color: var(--ux-text-secondary);
          }
        }
        .description {
          margin-top: 20px;
          padding: 20px 0;
          border-top: 1px solid rgba(255, 255, 255, 0.12);
          border-bottom: 1px solid rgba(255, 255, 255, 0.12);
          .desc_title {
            font-size: 20px;
            font-weight: 500;
            margin-bottom: 10px;
            color: var(--ux-text-primary);
          }
          .desc_content {
            font-size: 17px;
            line-height: 1.6;
            color: var(--ux-text-secondary);
            white-space: pre-wrap;
          }
        }

        .sku {
          display: flex;
          align-items: center;
          .sku_title {
            font-size: 24px;
            width: 120px;
            color: var(--ux-text-primary);
          }
          .sku_list {
            display: flex;
            flex-wrap: wrap;
            .no-sku {
              color: var(--ux-text-muted);
              font-size: 15px;
            }
          }
        }
        .size {
          display: flex;
          align-items: center;
          margin-top: 48px;
          .size_title {
            font-size: 24px;
            width: 120px;
            color: var(--ux-text-primary);
          }
          .size_list {
            .item {
              width: 232px;
              height: 51px;
              border-radius: 10px;
              line-height: 51px;
              text-align: center;
              background: rgba(255, 255, 255, 0.12);
              border: 1px solid rgba(255, 255, 255, 0.2);
              color: var(--ux-text-primary);
              font-size: 16px;
              font-weight: 500;
            }
          }
        }
        .shuliang {
          display: flex;
          align-items: center;
          margin-top: 50px;
          .shuliang_title {
            font-size: 24px;
            width: 120px;
            color: var(--ux-text-primary);
          }
          .counter {
            display: flex;
            .left1 {
              width: 43px;
              height: 43px;
              border-radius: 10px;
              background: var(--ux-surface-muted);
              font-weight: 400;
              font-size: 26px;
              color: var(--ux-text-primary);
              line-height: 43px;
              text-align: center;
              cursor: pointer;
            }
            .mid {
              width: 84.43px;
              height: 43px;
              border-radius: 10px;
              border: 1px solid rgba(37, 37, 35, 0.5);
              font-weight: bold;
              font-size: 24px;
              color: var(--ux-text-primary);
              line-height: 43px;
              text-align: center;
              font-style: normal;
              text-transform: none;
              margin: 0 28px;
            }
            .right {
              width: 43.56px;
              height: 43px;
              border-radius: 10px;
              background: var(--ux-surface-muted);
              font-weight: 400;
              font-size: 26px;
              color: var(--ux-text-primary);
              line-height: 43px;
              text-align: center;
              cursor: pointer;
            }
          }
          .stock-tip {
            margin-left: 15px;
            font-size: 15px;
            .stock-warning {
              color: #f56c6c;
            }
            .stock-low {
              color: #e6a23c;
            }
          }
        }
      }
    }
  }
  .author {
    margin-top: 27px;
    padding-left: 22px;
    .author_title {
      font-size: 24px;
      color: var(--ux-text-primary);
    }
    .author_content {
      display: flex;
      align-items: center;
      margin-top: 37px;
      margin-bottom: 20px;
      img {
        width: 85px;
        height: 85px;
        margin-right: 26px;
        border-radius: 50%;
        object-fit: cover;
      }
      .tips {
        font-size: 16px;
        .artist_name {
          font-weight: 500;
          margin-bottom: 8px;
        }
        .artist_desc {
          font-size: 15px;
          color: var(--ux-text-secondary);
          line-height: 1.5;
        }
      }
    }
  }
  .detail {
    margin-top: 40px;
    .detail_title {
      padding-left: 35px;
      font-size: 24px;
      color: var(--ux-text-primary);
      border-bottom: 1px solid rgba(255, 255, 255, 0.2);
      padding-bottom: 37px;
    }
    .detail_content {
      margin-top: 40px;
      padding-bottom: 40px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .detail_images {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        .detail_img {
          max-width: 770px;
          width: 100%;
          height: auto;
          border-radius: 10px;
        }
      }
      .detail_html {
        max-width: 770px;
        width: 100%;
        margin-top: 20px;
        color: var(--ux-text-secondary);
        font-size: 16px;
        line-height: 1.7;
        :deep(p) {
          color: var(--ux-text-secondary);
          line-height: 1.7;
        }
        :deep(h1, h2, h3, h4) {
          color: var(--ux-text-primary);
          line-height: 1.4;
          margin: 18px 0 10px;
        }
        :deep(img) {
          max-width: 100%;
          height: auto;
          border-radius: 10px;
        }
      }
    }
  }
}

.button_list {
  display: flex;
  margin-top: 90px;
  .button {
    width: 200px;
    height: 65px;
    line-height: 65px;
    font-size: 20px;
    font-weight: 400;
    border-radius: 10px;
    // color: var(--ux-text-primary);
  }
  .m-r-28 {
    margin-right: 28px;
  }
}
.tag_item {
  // width: 200px;
  height: 50px;
  padding: 0 20px;
  border-radius: 10px;
  line-height: 50px;
  text-align: center;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: var(--ux-text-primary);
  font-size: 16px;
  font-weight: 500;
  // margin-bottom: 15px;
  cursor: pointer;
  // margin-left: 20px;
  transition: all 0.2s ease;
}
.tag_item:hover {
  border-color: rgba(246, 75, 0, 0.55);
}
.tag_active {
  background: rgba(246, 75, 0, 0.2);
  border: 2px solid #f64b00;
  color: #ffd7bd;
  box-shadow: 0 0 0 2px rgba(246, 75, 0, 0.12);
}
</style>
